import Vue from 'vue';
import storage from './tools/storage';

/**
 * 初始化 store
 */
let state = {
  layout: 'list',
  // 上传文件数
  uploadNum: 0,
  // 下载文件数
  downloadNum: 0,
  // 页面失效时间
  expiredTime: 0,

};
const store = Vue.observable(state);

/**
 * 初始化 mutations
 */
const mutations = {

  // 获取 store 的数据
  synchronousData(obj) {
    state = { ...state, ...obj };
  },
};

const sessionStore = storage.get('store');
if (sessionStore) {
  const obj = !sessionStore || sessionStore === 'undefined' ? {} : sessionStore;
  mutations.synchronousData(obj);
}

export { store, mutations };
